//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileResource",
  props: {
    resType: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    // 取前5项（id 1,2,3,4,6），跳过id=5
    resourceList: function resourceList() {
      return (this.resType || []).filter(function (item) {
        return item.id !== 5;
      }).slice(0, 5);
    },
    cssVars: function cssVars() {
      return {
        "--mr-spacing": "16px",
        "--mr-radius": "12px",
        "--mr-text": "#1a1a2e",
        "--mr-padding-top": "20px",
        "--mr-section-title-font-size": "16px",
        "--mr-section-title-mb": "12px",
        "--mr-grid-gap": "10px",
        "--mr-item-height": "100px",
        "--mr-item-last-height": "90px",
        "--mr-num-font-size": "24px",
        "--mr-name-font-size": "13px",
        "--mr-name-mt": "2px"
      };
    }
  },
  methods: {
    getBgImg: function getBgImg(id) {
      var validIds = [1, 2, 3, 4, 6];
      var idx = validIds.indexOf(id);
      var n = idx >= 0 ? idx + 1 : 1;
      try {
        return require("@/assets/home_phone/res_".concat(n, ".png"));
      } catch (e) {
        return "";
      }
    },
    handleClick: function handleClick(item) {
      console.log("[MobileResource] handleClick fired, item:", JSON.stringify(item));
      this.$emit("go-next", item);
    }
  }
};